import React, { useEffect, useState } from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { CheckBox, DateBox, NumberBox, SelectBox, TagBox, TextArea } from 'devextreme-react';
import { TextBox } from 'devextreme-react/text-box';
import saveIconWhite from '../../../images/save-icon-white.svg';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/modal/modalSlice';
import { createCustomer, editCustomer } from '../../../redux/customers/thunks';
import { getContract, updateContract, updateContractSimple } from '../../../redux/contract/thunks';
import { errorHandler } from '../../../commonFunctions/errorHandler';
import dayjs from 'dayjs';
import { convertToLocalTime } from '../../../commonFunctions/commonFunctions';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="input-admin">
      <label className={classes?.label}>{label}</label>
      <div style={{ width: '75%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

function ContractDialog(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { contract, dialogSize, open, onClose } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const datetimePTBRFormat = "DD/MM/YYYY HH:mm"
  const jsonDatetimeFormat = "YYYY-MM-DDTHH:mm:ssZ" // yyyy-MM-ddTHH:mm:ssZ 
  

  function formatDate(value){
    if (value == null || value == undefined) return;
    return dayjs(value, datetimePTBRFormat).toDate()
  }

  const dialogStyles = {
    // width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
    // height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
    width: '550px',
    height: '100%',
    minWidth: 'max-content',
  };

  const buttonStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    margin: 'auto',
    marginTop: '5px',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const buttonSaveStyles = {
    padding: '6px 16px',
    fontSize: '13px',
    marginRight: '16px',
    marginTop: '5px',
    float: 'right',
    borderRadius: '0',
    color: 'white',
    backgroundColor: '#3B5158',
  };

  const closeButton = {
    position: 'absolute',
    right: '6px',
    top: '0px',
  };


  const [dataForm, setDataForm] = useState({});
  const [formOperation, setFormOperation] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const [title, setTitle] = useState();
  const [operation, setOperation] = useState();

  const dealers = [
    { id:1001, description: "ProAuto Europa- Sao Paulo/SP" },
    { id:1002, description: "Carrera Morumbi - Sao Paulo/SP" },
    { id:1003, description: "ProAuto Sumaré - Sao Paulo/SP" },
    { id:1004, description: "Carrera Gastão - Sao Paulo/SP" },
    { id:1005, description: "Amazonas Zona Norte - Sao Paulo/SP" },
    { id:1006, description: "Automob Mogi - Mogi das Cruzes/SP" },
    { id:1007, description: "Carrera Cotia - Cotia/SP" },
    { id:1008, description: "Sinal Alphaville - Barueri/SP" },
    { id:1009, description: "Amazonas Anália Franco - Sao Paulo/SP" },
    { id:1010, description: "Automob SJC - Sao Jose dos Campos/SP" },
    { id:1011, description: "Comeri - Santos/SP" },
    { id:1012, description: "Stefanini - Jundiai/SP" },
    { id:1013, description: "Abrao Reze - Sorocaba/SP" },
    { id:1014, description: "Santa Emilia - Ribeirao Preto/SP" },
    { id:1015, description: "Automob Gru - Guarulhos/SP" },
    { id:1016, description: "Stefanini Pascoal - Piracicaba/SP" },
    { id:1017, description: "Stefanini - Campinas/SP" },
    { id:1018, description: "Sinal SBC - Sao Bernardo do Campo/SP" },
    { id:1019, description: "Sinal SCS - Sao Caetano do Sul/SP" },
    { id:1020, description: "Jorlan SIA 1 - Brasilia/DF" },
    { id:1021, description: "Jorlan Aeroporto - Brasilia/DF" },
    { id:1022, description: "Lider - Vila Velha/ES" },
    { id:1023, description: "Lider - Vitoria/ES" },
    { id:1024, description: "Navesa - Goiania/GO" },
    { id:1025, description: "Automob - Sao Luis/MA" },
    { id:1026, description: "Canopus - Varzea Grande/MT" },
    { id:1027, description: "Raviera - Campo Grande/MS" },
    { id:1028, description: "Jorlan Barão - Belo Horizonte/MG" },
    { id:1029, description: "Jorlan Pampulha - Belo Horizonte/MG" },
    { id:1030, description: "Urca - Uberlandia/MG" },
    { id:1031, description: "Servopa - Curitiba/PR" },
    { id:1032, description: "Servopa - Londrina/PR" },
    { id:1033, description: "Servopa - Maringa/PR" },
    { id:1034, description: "Lider - Niteroi/RJ" },
    { id:1035, description: "Dr Sul - Porto Alegre/RS" },
    { id:1036, description: "Superauto BR  - Balneário Camboriu/SC" },
    { id:1037, description: "Superauto BR Kobrasol - Florianopolis/SC" },
    { id:1038, description: "Superauto BR Beira Mar - Florianopolis/SC" },
    { id:1039, description: "HG - Aracaju/SE" },
    { id:1040, description: "A. Candido - Natal/RN" },
    { id:1041, description: "A. Candido - Joao Pessoa/PB" },
    { id:1042, description: "HWS Rogaciano Leite - Fortaleza/CE" },
    { id:1043, description: "HWS Santos Dumont - Fortaleza/CE" },
    { id:1044, description: "A. Candido - Maceio/AL" },
    { id:1045, description: "Indiana - Salvador/BA" },
    { id:1046, description: "Canopus - Manaus/AM" },
    { id:1047, description: "Canopus - Belem/PA" },
    { id:1048, description: "Canopus - Palmas/TO" },
    { id:1049, description: "Autonunes - Recife/PE" },
    { id:1050, description: "Jelta - Teresina/PI" },
    { id:1051, description: "Premium Rio Barra  - Rio de Janeiro/RJ" },
    { id:1052, description: "Premium Rio Zona Sul - Rio de Janeiro/RJ" },
    { id:1053, description: "Barigui - Joinville/SC" },
    { id:1054, description: "Barigui - Blumenau/SC" },
    { id:1055, description: "Carrera SJRP - Sao Jose do Rio Preto/SP" },
    { id:1056, description: "Javep - Bauru/SP" },
    { id:1057, description: "Javep - Aracatuba/SP" },
    { id:1058, description: "Javep - Presidente Prudente/SP" },
    { id:1059, description: "Sinal - Indianópolis/SP" },
    { id:1060, description: "Amazonas Anália Franco PV - Sao Paulo/SP" },
    { id:9001, description: "Navesa OFC - Goiania/GO" }
  ];
  
  useEffect(() => {
    if (open && contract) {
      setDataForm({
        Id: contract.id,
        DealerCode: parseInt(contract.dealerCode),
        Dealer: contract.dealer,
        SalesDate: (contract.salesDate != null && contract.salesDate != '') ? contract.salesDate : null,
        DeliveryDate: (contract.deliveryDate != null && contract.deliveryDate != '') ? contract.deliveryDate : null
      });
      setTitle(contract?.customerId == null ? 'Cadastrar Cliente' : 'Editar Cliente');
      setOperation(contract.customerPhone == null ? 'delete' : '');
    }
  }, [open]);

  function onChange(main, value) {
    if (value == null || value == undefined) return;
    if (main.toLowerCase() === 'salesdate' || main.toLowerCase() === 'deliverydate') value = dayjs(value).format(datetimePTBRFormat);

    setDataForm((prevState) => ({ ...prevState, [main]: value }));
  }

  function onChangeDealer(value) {
    if(value == null || value == undefined) return null;

    const dealer = dealers.find(d => d.id == value);
    onChange('DealerCode', dealer.id)
    onChange('Dealer', dealer.description)
  }

  async function handleSubmit() {
    setIsSubmitting(true);

    try {
      if (contract.id == null) {
        //await dispatch(createCustomer({ body: customerDataForm }));
        // dispatch(createCustomer({ body: dataForm })).then((data) => {
        //     if(data.error)
        //       dispatch(openModal({ type: "warning", message:data.error.message}))
        //     else{
        //       dispatch(getContract({ query: '?plate=' + dataForm.Phone }));
        //       onClose();
        //     }
        // })
      } else {
        //await dispatch(editCustomer({ body: customerDataForm }));
        const bodyData = {
            DealerCode: dataForm?.DealerCode != null ? String(dataForm?.DealerCode) : null,
            Dealer: dataForm?.Dealer != null ? String(dataForm?.Dealer) : null,
        }
        if(dataForm?.SalesDate) bodyData.SalesDate = dayjs(dataForm?.SalesDate, datetimePTBRFormat).format(jsonDatetimeFormat);
        if(dataForm?.DeliveryDate) bodyData.DeliveryDate = dayjs(dataForm?.DeliveryDate, datetimePTBRFormat).format(jsonDatetimeFormat);

        const editParams ={
            param: contract.id,
            contractId: contract.id,
            body: bodyData
        }

        dispatch(updateContractSimple(editParams)).then((data) => {
            if(data.error)
              dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
              dispatch(getContract({ query: '?plate=' + contract.customerPhone }));
              onClose();
            }
            setIsSubmitting(false); 
        })    
      }
      
    } catch (err) {
      dispatch(openModal(errorHandler(err)));
      setIsSubmitting(false); 
    }
  }

  return (
    <Dialog maxWidth={'xl'} open={open} onClose={onClose} style={{ borderRadius: 0 }}>
      <div style={dialogStyles}>
        <DialogTitle disableTypography className="titleStyles">
          {title}
          {/* {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>} */}
          <IconButton onClick={onClose} style={closeButton}>
            <Close />
          </IconButton>
        </DialogTitle>
        <hr class="MuiDivider-root" style={{ width: '100%', backgroundColor: 'black' }}></hr>

        <DialogContent>
          <div style={{ display: 'flex', flexFlow: 'column', rowGap: '1rem' }}>

            <SelectBox
              label={"Dealer"}
              name="Dealer"
              dataSource={dealers}
              showClearButton={true}
              // acceptCustomValue
              // onCustomItemCreating={customItemCreating}
              value={dataForm?.DealerCode}
              //displayExpr={"description"}
              displayExpr={(item) => item == null ? null :  `(${item?.id}) - ${item?.description}`} 
              valueExpr={"id"}
              onValueChanged={(e) => onChangeDealer(e.value)}
              searchEnabled={true}
            ></SelectBox>

             {/* <TextBox label={'DealerCode'} key={'DealerCode'} name="DealerCode" value={dataForm?.DealerCode} onValueChanged={(e) => onChange('DealerCode', e.value)}></TextBox>
              <TextBox label={'Dealer'} key={'Dealer'} name="Dealer" value={dataForm?.Dealer} onValueChanged={(e) => onChange('Dealer', e.value)}></TextBox> */}

            <DateBox
              label={'Data de venda'}
              labelMode="floating"
              type="datetime" // Enables both date and time selection
              //pickerType="calendar" // Displays a calendar for date selection
              showAnalogClock={true}
              displayFormat="dd/MM/yyyy HH:mm"
              defaultValue={dayjs()}
              value={(dataForm?.SalesDate != null && dataForm?.SalesDate != "") ? formatDate(dataForm?.SalesDate) : null}
              onValueChanged={(e) => onChange('SalesDate', e.value)}
              />
            <DateBox
              label={'Data de entrega'}
              labelMode="floating"
              type="datetime"
              //pickerType="calendar"
              showAnalogClock={true}
              displayFormat="dd/MM/yyyy HH:mm"
              defaultValue={dayjs()}
              value={(dataForm?.DeliveryDate != null && dataForm?.DeliveryDate != "") ? formatDate(dataForm?.DeliveryDate) : null}
              onValueChanged={(e) => onChange('DeliveryDate', e.value)}/>
          </div>
        </DialogContent>
        <DialogActions>
          <div style={{ display: 'flex', gap: '1rem', paddingRight: 16 }}>
            {operation === 'delete' ? (
              <>
                <Button disabled={isSubmitting} variant="contained" onClick={onClose}>
                  Cancelar
                </Button>

                <Button disabled={isSubmitting} variant="contained" color="primary" onClick={handleSubmit} startIcon={<img src={saveIconWhite} />}>
                  Salvar
                </Button>
              </>
            ) : (
              <Button disabled={isSubmitting} variant="contained" color="primary" onClick={handleSubmit} startIcon={<img src={saveIconWhite} />}>
                Editar
              </Button>
            )}
          </div>
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default ContractDialog;